import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { TooltipModule } from 'primeng/tooltip';

import { SimulatorService } from './services/simulator/simulator.service';

import { SharedModule } from '../shared/shared.module';
import { VassCoreModule } from '../vass-core/vass-core.module';
import { PreSimulatorRoutingModule } from './pre-simulator-routing.module';

import { PreSimulatorFormComponent } from './components/pre-simulator-form/pre-simulator-form.component';
import { SimulationResultComponent } from './components/simulation-result/simulation-result.component';
import { PreSimulatorComponent } from './containers/pre-simulator/pre-simulator.component';

@NgModule({
  imports: [
    FormsModule,
    SharedModule,
    CommonModule,
    TooltipModule,
    VassCoreModule,
    TranslateModule,
    ReactiveFormsModule,
    PreSimulatorRoutingModule,
  ],
  providers: [],
  declarations: [
    PreSimulatorComponent,
    SimulationResultComponent,
    PreSimulatorFormComponent,
  ],
  exports: [PreSimulatorFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PreSimulatorModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [SimulatorService],
    };
  }
}
